import React, { useState } from 'react';
import PropTypes from 'prop-types';

import CollapsibleContainer from 'components/ui/CollapsibleContainer';
import FilterHeader from 'components/ui/FilterHeader';
import Flex from 'components/ui/Flex';
import { colors } from 'styleGuide';
import { toKebabCase } from 'utilities';

const Accordion = ({
  bordered,
  children,
  defaultShow,
  dense,
  onExpand,
  title,
}) => {
  const [expanded, setExpanded] = useState(defaultShow);
  const elementId = `${toKebabCase(title)}-container`;

  const toggle = () => {
    const isExpanding = expanded === false;
    setExpanded(!expanded);
    if (isExpanding && onExpand) {
      onExpand();
    }
  };

  return (
    <Flex direction="column" alignItems="stretch">
      <FilterHeader
        aria-controls={elementId}
        aria-expanded={expanded}
        bordered={bordered}
        caretColor={colors.blue.primary}
        collapsible={true}
        dense={dense}
        headerText={title}
        open={expanded}
        setOpen={toggle}
      />
      <CollapsibleContainer className="mb-3" isOpen={expanded} id={elementId}>
        {children}
      </CollapsibleContainer>
    </Flex>
  );
};

Accordion.propTypes = {
  bordered: PropTypes.bool,
  children: PropTypes.any,
  defaultShow: PropTypes.bool.isRequired,
  dense: PropTypes.bool,
  onExpand: PropTypes.func,
  title: PropTypes.string.isRequired,
};

Accordion.defaultProps = {
  bordered: false,
  defaultShow: false,
  dense: false,
  onExpand: () => null,
};

export default Accordion;
